import React from "react";
import PublicShell from "@/components/PublicShell";

export default function Terms() {
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-16">
        <div className="text-eyebrow text-[#4F4D45]">Terms of service</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-2">
          The agreement between you and FinVault.
        </h1>
        <p className="text-[#4F4D45] mt-4">Last updated: February 2026</p>

        <div className="mt-10 space-y-8 text-[#0A0A08] leading-relaxed">
          <Section title="1. Acceptance of terms">
            By creating a FinVault account, accessing our website, or using
            any service we provide, you agree to be bound by these Terms of
            Service and our Privacy Policy. If you do not agree, you must
            not use FinVault.
          </Section>
          <Section title="2. Eligibility">
            You must be at least 18 years old, legally able to enter into
            contracts, and not subject to any sanctions list to use
            FinVault. Business accounts require a duly authorized
            representative of the entity.
          </Section>
          <Section title="3. Account registration & identity verification">
            You must provide accurate personal or business information,
            complete email and (where applicable) two-factor verification,
            and pass our Know-Your-Customer (KYC) checks — including
            government-issued ID and a live face-match selfie — before
            transacting in Live mode or crypto. We may refuse, suspend, or
            terminate accounts that fail verification or appear fraudulent.
          </Section>
          <Section title="4. Services">
            FinVault provides multi-currency wallet functionality including
            deposits via PayPal-vaulted bank cards, internal transfers,
            withdrawals to verified bank methods, and a non-custodial
            gateway to MoonPay's regulated crypto buy, sell, and swap
            services. We do not act as a chartered bank, broker-dealer,
            money transmitter, or crypto custodian.
          </Section>
          <Section title="5. Non-custodial crypto">
            All crypto transactions execute directly between you and
            MoonPay. FinVault does not hold your coins, private keys, or
            seed phrases. You are solely responsible for the wallet
            addresses you provide and for safekeeping your private keys.
            Transactions on public blockchains are irreversible.
          </Section>
          <Section title="6. Fees">
            FinVault may charge platform fees disclosed at the point of
            transaction. PayPal, MoonPay, and blockchain networks charge
            their own fees, which are passed through to you. Pricing is
            subject to change with at least 14 days' notice via email.
          </Section>
          <Section title="7. Prohibited use">
            You agree not to use FinVault for money laundering, terrorist
            financing, sanctions evasion, fraud, market manipulation,
            unauthorized access to other accounts, or any activity that
            violates applicable law. We cooperate fully with law
            enforcement and financial regulators.
          </Section>
          <Section title="8. Security responsibilities">
            You are responsible for safeguarding your credentials,
            two-factor device, and recovery contact methods. Notify us
            immediately at support@finvault.capital if you suspect
            unauthorized access. FinVault is not liable for losses
            resulting from compromised credentials you failed to secure.
          </Section>
          <Section title="9. Suspension & termination">
            We may suspend or close any account that (a) fails KYC, (b)
            appears compromised, (c) violates these terms, or (d) is
            inactive for an extended period. You may close your account at
            any time after settling outstanding balances.
          </Section>
          <Section title="10. Disclaimers">
            FinVault is provided "as is" without warranties of any kind.
            Crypto assets are volatile and may lose value. Past
            performance is not indicative of future results. We do not
            provide investment, tax, or legal advice.
          </Section>
          <Section title="11. Limitation of liability">
            To the maximum extent permitted by law, FinVault and its
            affiliates shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages arising from your
            use of the platform.
          </Section>
          <Section title="12. Changes to these terms">
            We may amend these terms from time to time. Material changes
            will be communicated via email at least 14 days before they
            take effect. Continued use after the effective date
            constitutes acceptance.
          </Section>
          <Section title="13. Governing law">
            These terms are governed by the laws of the jurisdiction in
            which FinVault is incorporated, without regard to conflict-of-
            laws principles. Disputes shall be resolved by binding
            arbitration where permitted, otherwise by the competent
            courts of that jurisdiction.
          </Section>
          <Section title="14. Contact">
            For questions about these terms, email{" "}
            <a
              href="mailto:support@finvault.capital"
              className="text-[#1B3526] underline"
            >
              support@finvault.capital
            </a>
            .
          </Section>
        </div>
      </section>
    </PublicShell>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl md:text-2xl font-medium">{title}</h2>
      <p className="text-[#4F4D45] mt-3">{children}</p>
    </div>
  );
}
